// @ts-nocheck -- resolves against `highcharts-angular ^3.x`, which is
// not installed in every consumer. Consumers on v4+ (default) never
// load this file — see `highcharts-adapter.ts`. `@ts-nocheck` stops
// TypeScript from failing the v4+ consumer's build on the missing
// `HighchartsChartModule` export.
/**
 * highcharts-angular ^3.x adapter — exports the legacy NgModule as
 * `HighchartsChartHost`.
 *
 * Consumers pinned to `highcharts-angular ^3.x` (e.g. DCI /
 * `e3duiplatform-integratedintelligence-mfe` and any monolith that
 * consumes DCI as source) opt in to this file via
 * `angular.json` `fileReplacements` on their build target. Note that
 * TypeScript `compilerOptions.paths` will NOT work here because the
 * consumed import is relative (`./highcharts-adapter`).
 *
 * Example — in the monolith's `angular.json`:
 *
 *   "architect": {
 *     "build": {
 *       "options": {
 *         "fileReplacements": [
 *           {
 *             "replace": "<path>/eva-mfe/libs/eva/src/lib/ai-agent/highcharts-adapter.ts",
 *             "with": "<path>/eva-mfe/libs/eva/src/lib/ai-agent/highcharts-adapter.v3.ts"
 *           }
 *         ]
 *       }
 *     }
 *   }
 *
 * Replace `<path>` with the location of the eva-mfe submodule
 * relative to the monolith's project root (the directory containing
 * `angular.json`).
 */
import { HighchartsChartModule } from 'highcharts-angular';

export const HighchartsChartHost = HighchartsChartModule;
